<template>
  <div class="resultSignature_warpper">
    <nav-bar titleText="签名结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="goBack"
      :operationDisplab="operationDisplab"
      operationText="继续签名"
      :returnDisplab="returnDisplab"
      returnText="返回"
      instructions="签名成功"
      :imgSrc="imgSrc"
    >
      <p class="p1" v-if="allSigned == 0">已成功签名</p>
      <p class="p2" v-if="allSigned == 0">还有1份【{{contact_name}}】合同待签名</p>
      <p class="p2" v-if="allSigned == 1">已全部成功签名</p>
    </results-page>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import resultsPage from "../components/resultsPage";
export default {
  name: "resultSignature",
  data() {
    return {
      imgSrc: require("../../../assets/debtor/resultOk.png"),
      // 0 false  1 true  初始化为-1 因为需要等接口请求返回后才能决定
      allSigned: -1,
      shouldSign: '',
      contract_id: '',
      contact_name: '经纪人合同',
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.contact_name = this.$route.query.leavesigin
    this.getContractInfo()
  },
  computed: {
    operationDisplab(){
      return this.allSigned == 0
    },
    returnDisplab(){
      return this.allSigned == 1
    },
  },
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    goBack() {
      if (this.allSigned == 1) {
        this.$router.push('/agent/agentView')
        return
      }
      this.$router.push({
        path: '/debtRelief/wrDebtPersonHome',
        query: {
          token: localStorage.getItem('_token') || this.$route.query.token
        },
      })
      // this.$router.go(this.$route.query.gopage)
    },
   getContractInfo(){
     this.$api.post("/debt/member/agent/contract-list")
     .then(data => {
       this.contractInfo = data;
       this.allSigned = 0
        // this.contact_name = data.agent_contract_name;
       if (data.agent_contract_status == 1 && data.logo_contract_status == 1) {
         this.allSigned = 1
         // allSigned == 1时 下面两个不会被用到，所以不用赋值
        //  this.shouldSign = ''
        //  this.contract_id = ''
       }
       if (data.agent_contract_status == 1 && data.logo_contract_status == 0) {
         this.allSigned = 0
         this.shouldSign = 'logo'
         this.contract_id = data.logo_contract_id
       }
       if (data.agent_contract_status == 0 && data.logo_contract_status == 1) {
         this.allSigned = 0
         this.shouldSign = 'agent'
         this.contract_id = data.agent_contract_id
       }
       if (data.agent_contract_status == 0 && data.logo_contract_status == 0) {
         // TODO 这是签名结果页，按理不应该出现这种结果，如果出现了，那就是后端没有同步返回。可能就需要这边去重复请求处理
       }
       
       this.shouldSign
       this.contract_id
       
     })
   },
  
    handleOperationClick() {
      this.$router.push({
        path: '/debtor/signContract',
        query: {
          contract_id: this.contract_id,
          shouldSign: this.shouldSign, // or logo
          identity: 'agent',
        },
      })
    },
    handleReturnClick() {
      this.$router.push({
        path: '/agent/agentView',
      })
    },
  },
};
</script>
<style lang="less">
.resultSignature_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: 100%;
  font-size: 16px;
  color: #333;
  .p1 {
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    margin-bottom: 17px;
  }
  .p2 {
    height: 23px;
    font-size: 14px;
    color: #333333;
    line-height: 23px;
    margin-bottom: 36px;
  }
}
</style>
